import { render } from "./CouponManage.vue?vue&type=template&id=228d5a89&scoped=true"
import script from "./CouponManage.vue?vue&type=script&lang=js"
export * from "./CouponManage.vue?vue&type=script&lang=js"

import "./CouponManage.vue?vue&type=style&index=0&id=228d5a89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228d5a89"]])

export default __exports__